import { GenericAbortSignal } from "axios";
import { AutoCompleteDataModel, AutoCompleteSuggestions, MprcAutoComplete } from "components/MprcAutoComplete";
import { IAutoCompleteProps } from "components/MprcAutoComplete/AutoComplete";
import { StickerAppliesTo } from "generated/CoreApi_v1";
import { isCanceledError, useCoreApi } from "providers/CoreApiProvider";

////////////////////////////////////////////////////////////////////////////

interface IProps {
    applyTo: StickerAppliesTo;
    checkRestrictions: boolean;
    exceptStickerIds?: string[];
}

type Props = IProps & Omit<IAutoCompleteProps, 'onGetSuggestions' | 'emptyThumbnail'>;


////////////////////////////////////////////////////////////////////////////

/**
 * Auto complete de rótulos.
 * @param props
 */
export const StickerAutoComplete: React.FC<Props> = (props) => {

    const api = useCoreApi();

    const { applyTo, checkRestrictions, exceptStickerIds, onError } = props;

    ///
    const getSuggestions = (searchText: string, pageNumber: number, pageSize: number, trySelectedHistory: boolean, signal: GenericAbortSignal | undefined): Promise<AutoCompleteSuggestions<AutoCompleteDataModel>> => {
        searchText = searchText.toLowerCase();

        return new Promise<AutoCompleteSuggestions<AutoCompleteDataModel>>((resolve) => {
            api.v1.suggestions.stickers({
                searchText: searchText,
                applyTo: applyTo,
                checkRestrictions: checkRestrictions,
                exceptStickerIds: exceptStickerIds ?? [],
                pageNumber: pageNumber,
                pageSize: pageSize,
            }, { signal })
                .then(result => resolve({
                    items: result.data.items as AutoCompleteDataModel[],
                    totalRows: result.data.totalRows
                }))
                .catch(error => {
                    if (!isCanceledError(error)) {
                        resolve({ items: [], totalRows: 0 });
                        if (onError) onError(error);
                    }
                });
        });
    };

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <MprcAutoComplete
            {...props}
            onGetSuggestions={getSuggestions}
        />
    );
};
